export const language = {
  en: {
    'Change By Phone': 'Change By Phone',
    'Change By Email': 'Change By Email',
    'Phone Number': 'Phone Number',
    'Please Enter Phone Number': 'Please Enter Phone Number',
    'Please Enter Email Address': 'Please Enter Email Address',
    'Incorrect Phone Number Format': 'Incorrect Phone Number Format',
    'Incorrect Email Format': 'Incorrect Email Format',
    'Current Password': 'Current Password',
    'Please Enter Current Password': 'Please Enter Current Password',
    'New Password': 'New Password',
    '6-16 characters, must include letter, digit, and special character': '6-16 characters, must include letter, digit, and special character',
    'Invalid character: ': 'Invalid character: ',
    'Confirm Password': 'Confirm Password',
    'Passwords Do Not Match': 'Passwords Do Not Match',
    'Please Enter At Least 6 Characters': 'Please Enter At Least 6 Characters',
    'Change Password': 'Change Password',
  },
  zh: {
    'Change By Phone': '手机号修改',
    'Change By Email': '邮箱修改',
    'Phone Number': '手机号',
    'Please Enter Phone Number': '请输入手机号',
    'Please Enter Email Address': '请输入邮箱',
    'Incorrect Phone Number Format': '手机号格式不正确',
    'Incorrect Email Format': '邮箱格式不正确',
    'Current Password': '原密码',
    'Please Enter Current Password': '请输入原密码',
    'New Password': '新密码',
    '6-16 characters, must include letter, digit, and special character': '6-16位，必须包含字母、数字和特殊字符',
    'Invalid character: ': '无效字符：',
    'Confirm Password': '确认密码',
    'Passwords Do Not Match': '两次密码不一致',
    'Please Enter At Least 6 Characters': '最少6个字符',
    'Change Password': '修改密码',
  }
};